import { createAsyncThunk } from '@reduxjs/toolkit'
import {
    ConnectedAccountApi,
    ConnectedAccountDashboardApi,
    CreateStripeOnboardingLinkApi,
    GetStripeAccountStatusApi
} from './ConnectAccount.services'

export const ConnectedAccount = createAsyncThunk(
    '/Connected/Account',
    async (data, { rejectWithValue }) => {
        try {
            const res = await ConnectedAccountApi(data)
            return res
        } catch (err) {
            if (!err.response) {
                throw err
            }
            return rejectWithValue(err.response.data)
        }
    }
)
export const ConnectedAccountDashboard = createAsyncThunk(
    '/Connected/Account/dashboard',
    async (data, { rejectWithValue }) => {
        try {
            const res = await ConnectedAccountDashboardApi(data)
            return res
        } catch (err) {
            if (!err.response) {
                throw err
            }
            return rejectWithValue(err.response.data)
        }
    }
)
export const CreateStripeOnboardingLink = createAsyncThunk(
    '/Connected/Account/onboarding-link',
    async (data, { rejectWithValue }) => {
        try {
            const res = await CreateStripeOnboardingLinkApi(data)
            return res
        } catch (err) {
            if (!err.response) {
                throw err
            }
            return rejectWithValue(err.response.data)
        }
    }
)

export const GetStripeAccountStatus = createAsyncThunk(
    '/Connected/Account/account-status',
    async (data, { rejectWithValue }) => {
        try {
            const res = await GetStripeAccountStatusApi(data)
            return res
        } catch (err) {
            if (!err.response) {
                throw err
            }
            return rejectWithValue(err.response.data)
        }
    }
)
